import { LoadingButton } from "@mui/lab";
import { Alert, Box, TextField } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePasswordThunk } from "store/reducers/machine_ops/machineOpsSlice";
import * as yup from "yup";

const validation = yup.object({
  new_password1: yup
    .string("Enter a new password")
    .min(6, "Password must be at least 6 characters")
    .max(128, "Password cannot exceed 128 characters")
    .required("New password is required"),
  new_password2: yup
    .string("Confirm your new password")
    .oneOf([yup.ref("new_password1"), null], "Passwords must match")
    .required("Confirming your new password is required"),
});

const ChangeMachinePassword = ({ machine, open, handleClose }) => {
  const vendingState = useSelector((state) => state.machineOps);
  const dispatch = useDispatch();


  const formik = useFormik({
    initialValues: {
      new_password1: "",
      new_password2: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
        // console.log("data",{ id: machine.id ,data});
        dispatch(changePasswordThunk({ id: machine.id ,data}));
    },
  });

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Update machine credentials"
    >
      <Box paddingX={2}>
        <form onSubmit={formik.handleSubmit}>
          <Box display="flex" flexDirection="column" sx={{ mb: 2 }}>
            <TextField
              label="New password"
              variant="outlined"
              name="new_password1"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.new_password1}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.new_password1)}
              helperText={formik.errors.new_password1}
              autoComplete="new-password"
              required
              type="password"
            />
            <TextField
              label="Confirm new password"
              variant="outlined"
              name="new_password2"
              autoComplete="new-password"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.new_password2}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.new_password2)}
              helperText={formik.errors.new_password2}
              type="password"
            />
            {(vendingState.changingPassword.error || vendingState.changingPassword.errorMessage) && (
              <Alert sx={{ mt: 3 }} severity="error">
                {vendingState.changingPassword.errorMessage}
              </Alert>
            )}
            {(vendingState.changingPassword.success) && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
            <LoadingButton
              loading={
                vendingState.changingPassword?.loading 
              }
              variant="contained"
              sx={{ mt: 3 }}
              type="submit"
            >
              Update credentials
            </LoadingButton>
          </Box>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default ChangeMachinePassword;
